import React from 'react'
import { useAuth } from 'context/auth'
import AuthRoutes from './auth-routes'
import PublicRoutes from './public-routes'
import UserRoutes from './user-routes'
import { ROLES, TYPES } from 'enums/user'
import InvalidAccessRoutes from './unauthorize-routes'
import ChangePassRequiredRoutes from './change-pass-req-routes'

const Routes = () => {
  const { currentUser } = useAuth()
  const routes = PublicRoutes

  // PUBLIC
  if (!currentUser) return routes.concat(AuthRoutes)

  const validUserTypes = [TYPES.SUBSCRIBER]
  const validUserRoles = [ROLES.CONSUMER]

  // PREMISSION DENIED
  if (
    currentUser &&
    (!currentUser.roles.some((role) => validUserRoles.includes(role)) ||
      !validUserTypes.includes(currentUser.user_type))
  )
    return routes.concat(InvalidAccessRoutes)

  // CHANGE PASSWORD REQUIRED
  if (currentUser && currentUser.change_pass_required) {
    return routes.concat(ChangePassRequiredRoutes)
  }
  // USER
  return routes.concat(UserRoutes)
}

export default Routes
